// Email template data model
export interface EmailTemplate {
  id: string;
  logoUrl?: string | null;
  subject: string;
  html?: string; // sanitized HTML for sending
  json?: unknown; // Tiptap JSON for rehydration
  supportEmail?: string; // Studio support/contact email
  updatedAt: string;
}

// Available tokens for email personalization
export const EMAIL_TOKENS = {
  PARENT_FIRST_NAME: '{parent_first_name}',
  STUDIO_NAME: '{studio_name}',
  PASSWORD: '{password}',
  PARENT_PORTAL_LINK: '{parent_portal_link}',
} as const;

export type EmailToken = typeof EMAIL_TOKENS[keyof typeof EMAIL_TOKENS];

// Mock data for preview
export const PREVIEW_TOKEN_VALUES: Record<string, string> = {
  '{parent_first_name}': 'Alex',
  '{studio_name}': 'Enrollio Demo', // Will be replaced with actual studio name in preview
  '{password}': '83K-2M9',
  '{parent_portal_link}': 'https://portal.example.com',
};

